import { render, staticRenderFns } from "./adminBoard.vue?vue&type=template&id=3f9a29ce&scoped=true"
import script from "./adminBoard.vue?vue&type=script&lang=js"
export * from "./adminBoard.vue?vue&type=script&lang=js"
import style0 from "./adminBoard.vue?vue&type=style&index=0&id=3f9a29ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9a29ce",
  null
  
)

export default component.exports